<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('slbsetting.pageTitleText') }}
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
            p Manage your Virtual SLB.

        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :drawerTitleKey="drawerTitleKey"
            :sort="sort"
            ref="rcmTable"
            :viewSlotInfo="viewSlotInfo"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="hostname"
            :primarySearchKeyI18="$t('slbsetting.hostname')"
            :isCreateBtnDisabled="!$can('write', 'groupResourcesPermission','VirtualSlbsManage')"
            :isEditBtnDisabled="!$can('write', 'groupResourcesPermission','VirtualSlbsManage')"
            :isDeleteBtnDisabled="!$can('write', 'groupResourcesPermission','VirtualSlbsManage')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("TagList", TagList);
Vue.component("LineOptimize", LineOptimize);

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import LineOptimize from "@/components/SlbSetting/LineOptimize";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { getRegionInfo } from "@/api/3rd/17ce.js";
import { settingZoneExplain, groupName, serviceIP, isEnabled, hostName, line, action } from "./fields.js";

export default {
    name: "VirtualSlbSetting",
    components: { RcmTable, TagList, LineOptimize },
    data() {
        return {
            viewSlotInfo: {
                slbclients: [],
            },
            esIndex: "rcm-slbs",
            drawerTitleKey: "hostname",
            sort: [{ modifiedDate: { order: "desc" } }],
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("slbsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [
                { sectionKey: "essential", isOpened: true },
                { sectionKey: "healthCheck", isOpened: false },
                { sectionKey: "advanced", isOpened: false },
            ];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`slbsetting.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostName(this),
                      _id: {},
                      health: {},
                      isenabled: isEnabled(this),
                      recordType: { sectionKey: "essential" },
                      serviceIP: serviceIP(this),
                      isDummySlb: {},
                      lineOptimize: {},
                      line: line(this),
                      serviceProvideType: {},
                      externalCheckInfo: {},
                      isEnabledExternalCheck: {},
                      checkTimesAsHealthy: {},
                      checkTimesAsUnhealthy: {},
                      usedHealthCheckProbes: {},
                      externalCheckUrl: {},
                      errMsg: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: action(this),
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: groupName(this),
                      hostname: hostName(this),
                      _id: {},
                      health: {},
                      isenabled: isEnabled(this),
                      recordType: { sectionKey: "essential" },
                      serviceIP: serviceIP(this),
                      isDummySlb: {},
                      lineOptimize: {},
                      line: line(this),
                      serviceProvideType: { withForm: false },
                      // externalCheckInfo: {},
                      // isEnabledExternalCheck: {},
                      // checkTimesAsHealthy: {},
                      // checkTimesAsUnhealthy: {},
                      // usedHealthCheckProbes: {},
                      // externalCheckUrl: {},
                      errMsg: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.$options.name);
            },
        },
    },
    methods: {},
    mounted() {
        this.$socket.emit("getslbclients");
        if (this.$store.state.backendData.thirdParty.lineOptimize.regionInfo.length == 0) {
            getRegionInfo().then((res) => {
                this.$store.commit("SET_REGION_INFO", res.data.data);
            });
        }
    },
    sockets: {
        updateslbclients: function (clients) {
            this.viewSlotInfo.slbclients = clients;
        },
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.$options.name);
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent) => {
            bus.$emit(busEvent);
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/VirtualSlbSetting/Page.vue